<template>
  <div>
    <meta charset="utf-8">
    <!-- <container> -->

    <div v-if="isDetailApi" style="float:right" id="apierror">
      <p style=" color:red; font-size:13px;text-align:right;"><span style="font-size: 13px;">&#9888;</span> API Issue
        Getting Runner Details</p>
      <button id="Diagnose" class="btn btn--primary" @click="diagnose()">&#9960; Diagnose</button>
      <ul style="list-style-type: none;">
        <li v-for="id in badRunners" style="display: block;">
          <div class="chip">
            {{ id }}

            <button @click="removeRunner(id)">&#10005;</button>
          </div>
        </li>
      </ul>
      <div v-if="loading" class="loader"></div>

    </div>


    <div class="flex btnContainer">
      <div style="width: 92%;">
        <button id="loaddata" class="btn leftbtn loadRunnersBtn roundBtn" v-if="notStarted"
                @click="loaddata()" :disabled="loadingRunners">
          Load Runners
        </button>

        <button class="btn leftbtn freezeBtn roundBtn" @click="freeze()"
                v-if="!notStarted && !isFreeze && status!='finished'">
          Freeze
        </button>

        <button class="btn leftbtn unfreezeBtn roundBtn" @click="unfreeze()"
                v-if="!notStarted && isFreeze && status!='finished'">
          Unfreeze
        </button>
        <button
          id="downloadcsv"
          class="btn btn--primary load_data"
          v-if="tableData"
          style="float: right;margin-left:10px"
          @click="loadDataForExportCsv()"
          :disabled="isExportAsCsv || loading"
        >Export as CSV
        </button>

      </div>

      <div style="width: 7%;">
        <toggle-button
          id="changed-font"
          @change="onToggle()"
          v-model="distanceInKm"
          :width="85"
          :height="30"
          :speed="480"
          :color="{unchecked: '#413b94', checked: '#ff5627'}"
          :labels="{checked: 'Km', unchecked: 'Miles'}"
        />
      </div>

    </div>


    <div style="float:right; font-size: large;">
      <div id="top-scroll" style="width:704.688px; overflow-x: scroll; overflow-y:hidden;" hidden>
        <div id="scroll-inner" style="width:1542px; height: 5px;"></div>
      </div>
    </div>


    <div v-if="!this.$props.isPastRun" class="runner-table" style="margin-top: 10px;">
      <v-table
        is-horizontal-resize
        :is-loading="loading"
        :columns="columns"
        style="width:100%;font-size:10.5px"
        :column-cell-class-name="columnCellClass"
        :table-data="tableData"
        :show-vertical-border="true"
        :odd-bg-color="'#cfe2f3'"
        :title-row-height="60"
        :row-height="45"
        :border="1"
        :filter-method="filterMethod"
        @on-custom-comp="customCompFunc">
      </v-table>


      <div class="pager_btns">

        <runner-pagination
          :total="totalItems"
          :totalJoinedRunner="totalJoinedRunner"
          :currentPageIndex='pageIndex'
          @changePage="onChangePage"
          :disableDefaultStyles="true"
          :isFilterOn="filterRunner"
        ></runner-pagination>

        <div class="filter-btn">
          <button class="totalPaceBtn" :disabled="filterRunner && !filterTotalPace"
                  @click="filterRunnerData('totalPace')"
                  title="Filter runners with total pace above 90% of their target pace. Useful for identifying high-performing runners.">Total Pace
          </button>
          <button class="totalRunBtn" :disabled="filterRunner && !filterTotalRuns"
                  @click="filterRunnerData('totalRuns')"
                  title="Filter runners based on their total number of completed runs. Helps track participation frequency."># Of Run
          </button>
          <button class="totalDistanceBtn" :disabled="filterRunner && !filterTotalDistance"
                  @click="filterRunnerData('totalDistance')"
                  title="Filter runners based on their total distance covered. Useful for tracking overall distance achievements.">Total KM
          </button>
          <button class="ekidenBtn" :disabled="filterRunner && !filterEkiden"
                  @click="filterRunnerData('Ekiden')"
                  title="Filter runners participating in Ekiden relay races. Shows team-based race participants.">
            Ekiden
          </button>
        </div>


      </div>

      <lucky-live-runner :details="detail" :show="showModal" @saved="onSaved" @closed="onClosed"></lucky-live-runner>
      <bonus-distance-modal :details="detail" :show="showBonusModal" @saved="onSaved"
                            @closed="onClosed"></bonus-distance-modal>
    </div>


    <div v-if="this.$props.isPastRun" class="runner-table" style="margin-top: 10px;">
      <v-table
        is-horizontal-resize
        :columns="columns"
        style="width:100%;font-size:10.5px"
        :column-cell-class-name="columnCellClass"
        :table-data="tableData"
        :show-vertical-border="true"
        :odd-bg-color="'#cfe2f3'"
        :title-row-height="60"
        :border="1"
        :row-height="45"
        :filter-method="filterMethod"
        :is-loading="loading"
      ></v-table>
      <div class="pager_btns">
        <runner-pagination
          :total="totalItems"
          :totalJoinedRunner="totalJoinedRunner"
          :currentPageIndex='pageIndex'
          @changePage="onChangePage"
          :disableDefaultStyles="true"
        ></runner-pagination>

        <div class="filter-btn">
          <button class="totalPaceBtn" :disabled="filterRunner && !filterTotalPace"
                  @click="filterRunnerData('totalPace')">Total Pace
          </button>
          <button class="totalRunBtn" :disabled="filterRunner && !filterTotalRuns"
                  @click="filterRunnerData('totalRuns')"># Of Run
          </button>
          <button class="totalDistanceBtn" :disabled="filterRunner && !filterTotalDistance"
                  @click="filterRunnerData('totalDistance')">Total KM
          </button>
          <button class="ekidenBtn" :disabled="filterRunner && !filterEkiden" @click="filterRunnerData('Ekiden')">
            Ekiden
          </button>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import 'vue-easytable/libs/themes-base/index.css'
import {VTable, VPagination} from 'vue-easytable'
import Container from '@/components/Container'
import RunnerPagination from '@/components/Forms/RunnerPagination'
import Vue from "vue"
import axios from 'axios'

Vue.component(VTable.name, VTable)
Vue.component(VPagination.name, VPagination)
var pastRunTimeOut
import {mapGetters} from 'vuex'
import {db} from '../../../firebase'
import RunnersByRaceService from '../../../services/runnersByRace'
import * as WebSocketService from '../../../services/webSocket'
import SocketService from '../../../services/Socket'
import {Name} from '../../../../public/my.env'
//import {prop, sortWith,sort, descend, ascend} from 'ramda'
import * as R from 'ramda'
import LuckyLiveRunner from './LuckyLiveRunner'
import BonusDistanceModal from './BonusDistanceModal'

let dialogOptions = {
  html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
  loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
  reverse: false, // switch the button positions (left to right, and vise versa)
  cancelText: 'No',
  okText: 'Yes',
  animation: 'zoom', // Available: "zoom", "bounce", "fade"
  type: 'basic', // coming soon: 'soft', 'hard'
  verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
  clicksCount: 3,
  animation: 'bounce', // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
}
export default {
  name: 'runners-table',
  computed: mapGetters({
    runners: 'Race/runners',
    race: 'Race/race',
    questions: 'RaceQuestion/raceQuestion'
  }),
  props: {
    isPastRun: Boolean
  },
  data: () => ({
    distanceInKm: true,
    tableData: [],
    gender: 'All',
    totalPaceVal: 'All',
    isLoading: true,
    columns: [{
      field: "rank",
      title: 'Rank',
      width: 50,
      titleAlign: 'center',
      columnAlign: 'center',
      isFrozen: true,
      componentName: 'luckylive-runner-modal'
    },
      {
        field: "firstName",
        title: 'Runner Name',
        width: 95,
        titleAlign: 'center',
        columnAlign: 'center',
        formatter: function (rowData, rowIndex, pagingIndex, field) {
          return rowData.isNew ? '<span style="color:red; font-weight: bold;">' + rowData.firstName + '</span>' :  rowData.firstName;
        },
        isFrozen: true,
        componentName: 'runner-name'
      },
      {
        field: "lastName",
        title: 'Location',
        width: 120,
        titleAlign: 'center',
        columnAlign: 'center',
        isFrozen: true,
        componentName: 'runmetrix-page'
      },
      {
        field: "catchPhrase",
        title: 'CatchPhrase',
        width: 120,
        titleAlign: 'center',
        columnAlign: 'center',
        isFrozen: true
      },
      {
        field: "id",
        title: 'ID',
        width: 70,
        titleAlign: 'center',
        columnAlign: 'center',
        componentName: 'runner-id',
        isFrozen: true
      },
      // {field: "medal", title:'Mdl', width: 60, titleAlign: 'center',columnAlign:'center', componentName:'runner-medal', isFrozen: true},
      {field: "medal", title: 'Mdl', width: 60, titleAlign: 'center', columnAlign: 'center', isFrozen: true},
      {field: "memo", title: 'Memo', width: 120, titleAlign: 'center', columnAlign: 'center'},


      {
        field: "gender", title: 'Sex', width: 30, titleAlign: 'center', columnAlign: 'center',
        titleCellClassName: 'title-cell-class-name-gender',
        filterMultiple: false,
        filters: [{
          label: 'Male',
          value: 'M',
        }, {
          label: 'Female',
          value: 'F',
        }]
      },
      {
        field: "distance", title: 'distance/KM', width: 78, titleAlign: 'center',
        columnAlign: 'center', filterEkiden: 'filterEkiden',
        componentName: 'bonus-distance-modal'
      },
      {field: "gap", title: 'Gap (M)', width: 55, titleAlign: 'center', columnAlign: 'center'},
      {field: "pace", title: 'Current Pace(min/km)', width: 80, titleAlign: 'center', columnAlign: 'center'},
      {
        field: "totalPace", title: 'Total Pace (min/km)', width: 70, titleAlign: 'center', columnAlign: 'center',
        titleCellClassName: 'title-cell-class-name-pace',
        // filterMultiple: false,
        // filters: [{
        //     label: '90% ~ 100%',
        //     value: 'Above90',
        // }]
      },
      {
        field: "totalRuns", title: '#of Run', width: 55, titleAlign: 'center', columnAlign: 'center',
        titleCellClassName: 'title-cell-name-totalRuns'
      },
      {
        field: "totalDistance", title: 'Total KM', width: 65, titleAlign: 'center', columnAlign: 'center',
        titleCellClassName: 'title-cell-name-totalDistance'
      },

      // {field: "bonus", title:'Boost Distance', width: 65, titleAlign: 'center',columnAlign:'center',
      // titleCellClassName:'title-cell-name-totalDistance',
      // formatter: function (rowData,rowIndex,pagingIndex,field) {
      //                 return '<span style="color:red;font-weight: bold;">' + (parseFloat(rowData.bonus) + parseFloat(rowData.distance))+ '</span>'
      // }},

      {
        field: "daysSinceLastRun",
        title: 'Days since last LiveRuns',
        width: 60,
        titleAlign: 'center',
        columnAlign: 'center'
      },
      {
        field: "questionAnswer",
        title: 'Questionaire',
        width: 100,
        titleAlign: 'center',
        columnAlign: 'left',
        componentName: 'pre-post-answers',
        isResize: true
      }
    ],
    firbaseRunners: {},
    status: null,
    isComplete: true,
    isRequestComplete: false,
    isDetailApi: false,
    badRunners: [],
    loading: false,
    count: 0,
    raceCount: 0,
    loadingRunners: false,
    notStarted: false,
    expressApi: '',
    progressBarInterval: null,
    isRaceDataUpdated: false,
    uploadPercentage: 0,
    masterCheck: false,
    showModal: false,
    detail: {
      runner: {
        firstName: '',
        lastName: ''
      }
    },
    pageIndex: 1,
    pageTotal: null,
    pageSize: 50,
    loading: false,
    isFreeze: false,
    exampleItems: [],
    totalItems: 0,
    totalJoinedRunner: 0,
    currentRaceStatus: '',
    completeCount: 0,
    filterTotalDistance: false,
    filterTotalRuns: false,
    filterTotalPace: false,
    filterEkiden: false,
    liveStatus: '',
    runStatus: '',
    raceData: '',
    filters: {},
    filterRunner: false,
    connection: null,
    showBonusModal: false,
    isExportAsCsv: false
  }),
  methods: {
    // sendMessage(message) {
    //   console.log("message--",JSON.stringify(message))
    //  // console.log("connection--",this.connection)
    //   this.connection.send(JSON.stringify(message))
    // },
    columnCellClass(rowIndex, columnName, rowData) {
      if (columnName == 'catchPhrase' && rowData.catchPhrase != undefined && rowData.catchPhrase.length > 10) {
        if (rowData.isNotSubscribed) {
          return 'column-cell-class-name-test-memo gray'
        } else {
          return 'column-cell-class-name-test-memo '
        }
      }
      if (columnName == 'firstName' && rowData.firstName != undefined && rowData.firstName.length > 2) {
        if (rowData.isNotSubscribed) {
          return 'column-cell-class-name-firstname gray'
        } else {
          return 'column-cell-class-name-firstname '
        }
      }
      if (columnName == 'lastName' && rowData.lastName != null && rowData.lastName.length > 7) {
        return 'column-cell-class-name-test-memo'
      }
      if (this.race.duration != 15 && rowData.isDistanceGreater && columnName === 'distance') {
        return 'column-cell-class-name-red-text'
      }
      if (this.race.duration != 15 && rowData.isDistanceGreater && columnName === 'distance' && Number(rowData.distance) > Number(rowData.bestDistance)) {
        return 'column-cell-class-name-red-text'
      } else if (this.race.duration != 15 && Number(rowData.distance) > Number(rowData.bestDistance) && columnName === 'distance') {
        return 'column-cell-class-name-red-text'
      }

      if (rowData.isTotalPaceGreater && columnName === 'totalPace') {
        return 'column-cell-class-name-test'
      }

      if (rowData.totalPace.replace(/\D/g, '') > 89 && rowData.totalPace.replace(/\D/g, '') < 100 && columnName === 'totalPace') {
        return 'column-cell-class-name-pink'
      }

      if (columnName === 'questionAnswer') {
        return 'column-cell-class-name-test1'
      }
      // if (!rowData.isRunning) {
      //   return 'gray'
      // }


        //  if (rowData.memo != null && rowData.memo.length > 17){
        //     return 'column-cell-class-name-test-memo'
      //  }
      else if (rowData.isNotSubscribed) {
        return 'gray'
      } else {
        return ""
      }


    },

    async getRunnerData(raceId, loadRunners, loadUpdatedData, pageIndex) {
      console.log("SENDING REQUEST TO SOCKET XXX");

      if (typeof (loadRunners) == "undefined")
        loadRunners = 0
      const isnum = /^\d+$/.test(raceId)
      if (!isnum) {
        const myArray = raceId.split(/([0-9]+)/)
        raceId = myArray[1]
      }
      const AuthStr = 'Bearer '.concat(window.localStorage.getItem('default-auth-token'))
      if (this.isComplete) {
        this.isLoading = true
        this.loadingRunners = true
        this.isComplete = false
        this.filters = {
          'gender': this.gender,
          'filterTotalDistance': this.filterTotalDistance,
          'filterTotalRuns': this.filterTotalRuns,
          'filterEkiden': this.filterEkiden,
          'isExportAsCsv': this.isExportAsCsv
        }
        if (this.gender !== 'All' || this.filterTotalDistance || this.filterTotalRuns || this.filterTotalPace || this.filterEkiden) {
          this.filterRunner = true
        } else {
          this.filterRunner = false
        }

        console.log("SENDING REQUEST TO SOCKET");
        //SEND DATA TO WEBSOCKET
        const msg = {
          "Action": "GetRunnerData",
          "Data": {
            "raceId": this.$route.params.raceId,
            "raceDuration": this.race.duration * 60,
            "loadRunners": loadRunners,
            "staging": JSON.stringify(this.$isStage),
            "loadUpdatedData": loadUpdatedData,
            "pageIndex": pageIndex,
            "filters": this.filters,
            "filterRunner": this.isExportAsCsv ? true : this.filterRunner,
            "Authorization": AuthStr
          }
        }

        SocketService.send(msg)
      }
    },
    onChangePage(pager, OnClickPager) {
      //console.log("OnClickPager ---",OnClickPager)
      console.log("currentPage", pager.currentPage)
      var pageNo = pager.currentPage
      if (pager.currentPage == 0) {
        pageNo = 1
      }
      this.pageIndex = pageNo

      if (OnClickPager && this.filterRunner) {
        this.resetFilter()    //IF CLICK ON PAGER IS SHOW RUNNER 50RUNNER PER PAGE WITHOUT FILTER
      }

      if (this.notStarted) {
        this.loading = true
        this.getRunnerData(this.$route.params.raceId, 1, false, pageNo)
      } else if (this.status === "finished") {
        this.loading = true
        this.getRunnerData(this.$route.params.raceId, 1, true, pageNo)
      } else if (this.currentRaceStatus === 'running' || this.currentRaceStatus === 'StartRun' ) {
        this.getRunnerData(this.$route.params.raceId, 0, false, pageNo)
      }
    },
    pageSizeChange(pageSize) {
      // this.pageIndex = 1
      // this.pageSize = pageSize
      //this.getRunnerData(this.$route.params.raceId, 1, false,this.pageIndex)
    },
    resetFilter() {
      console.log("Reset filter ***")
      this.filterTotalDistance = false
      $(".totalDistanceBtn").removeClass("purple-bg")
      this.filterTotalRuns = false
      $(".totalRunBtn").removeClass("purple-bg")
      this.filterTotalPace = false
      $(".totalPaceBtn").removeClass("purple-bg")
      this.filterEkiden = false
      $(".ekidenBtn").removeClass("purple-bg")
    },
    freeze() {
      this.isFreeze = true
      var v = document.getElementById("dim-panel")
      v.className += " dimmer"
    },
    unfreeze() {
      this.isFreeze = false
      this.removeDimDiv()
    },
    loadDataForExportCsv() {
      this.isExportAsCsv = true
      this.getRunnerData(this.$route.params.raceId, 1, false, 1, true)
    },
    downloadCSVFirebase(dataList = []) {
      let csvData = []
      let tempRow = []
      this.columns.map((col) => {
        let val = col.title || ''
        val = val.replace('#', '')
        tempRow.push(val)
      })
      csvData.push(tempRow)
      const getValue = (value2) => {
        return value2.replace('#', '').replace(',', '').replace(/(\r\n|\n|\r)/gm, "").trim()
      }
      if (dataList.length) {
        dataList.map((runner, index) => {
          tempRow = []
          this.columns.map((col) => {
            let val2 = runner[col.field] || ''
            if (typeof val2 === 'string') {
              val2 = getValue(val2)
            }
            let val3 = ''
            if (col.title === 'Questionaire') {
              val3 = getValue(runner['postQuestionAnswer'] || '')
              tempRow.push(`"${val2}\n${val3}"`)
            } else {
              tempRow.push(val2)
            }
          })
          csvData.push(tempRow)
          tempRow = []
        })
        let csvContent = "data:text/csv;charset=utf-8,"
        csvData.map((infoArray, index) => {
          let dataString = infoArray.join(",")
          csvContent += dataString + "\n"
        })

        var downloadLink = document.createElement("a")
        downloadLink.href = csvContent
        const fId = this.race.id
        const fDate = new Date().toISOString().replace(/[^a-zA-Z0-9 ]/g, "-")
        downloadLink.download = `${fId ? fId + '-' : 'race-'}${fDate ? fDate : 'new'}.csv`
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
      }
      this.isExportAsCsv = false
    },

    filterRunnerData(field) {
      if (field == "totalDistance") {
        this.filterTotalDistance = !this.filterTotalDistance
      } else if (field == "totalRuns") {
        this.filterTotalRuns = !this.filterTotalRuns
      } else if (field == "totalPace") {
        this.filterTotalPace = !this.filterTotalPace
      }
      if (field == "Ekiden") {
        this.filterEkiden = !this.filterEkiden
      }
      console.log(">>>", this.filterTotalDistance, this.filterTotalRuns)

      if (this.filterTotalDistance) {
        $(".totalDistanceBtn").addClass("purple-bg")
      } else {
        $(".totalDistanceBtn").removeClass("purple-bg")
      }

      if (this.filterTotalRuns) {
        $(".totalRunBtn").addClass("purple-bg")
      } else {
        $(".totalRunBtn").removeClass("purple-bg")
      }

      if (this.filterTotalPace) {
        $(".totalPaceBtn").addClass("purple-bg")
      } else {
        $(".totalPaceBtn").removeClass("purple-bg")
      }

      if (this.filterEkiden) {
        $(".ekidenBtn").addClass("purple-bg")
      } else {
        $(".ekidenBtn").removeClass("purple-bg")
      }
      this.pageIndex = 1 //SET TO PAGE 1 WHEN FILTER
      this.checkRaceStatus()
    },

    // titleClick(title,field){
    //     if(field == "totalDistance"){
    //         this.filterTotalDistance = !this.filterTotalDistance
    //     }else if(field == "totalRuns"){
    //         this.filterTotalRuns = !this.filterTotalRuns
    //     }
    //     console.log(">>>",this.filterTotalDistance,this.filterTotalRuns)

    //     if(this.filterTotalDistance){
    //         $("td.title-cell-name-totalDistance").addClass("purple-bg")
    //     }else{
    //         $("td.title-cell-name-totalDistance").removeClass("purple-bg")
    //     }

    //     if(this.filterTotalRuns){
    //         $("td.title-cell-name-totalRuns").addClass("purple-bg")
    //     }else{
    //         $("td.title-cell-name-totalRuns").removeClass("purple-bg")
    //     }
    //     this.checkRaceStatus()
    // },
    filterMethod(filters) {
      console.log("filters---", filters.totalPace)
      if (Array.isArray(filters.gender)) {
        this.gender = filters.gender[0]
        $("td.title-cell-class-name-gender").addClass("purple-bg")
      } else if (filters.gender == null) {
        this.gender = 'All'
        $("td.title-cell-class-name-gender").removeClass("purple-bg")
      }
      this.pageIndex = 1 //SET TO PAGE 1 WHEN FILTER
      this.checkRaceStatus()
    },
    checkRaceStatus() {
      if (this.notStarted) {
        this.loading = true
        this.getRunnerData(this.$route.params.raceId, 1, false, this.pageIndex)
      } else if (this.status === "finished") {
        this.loading = true
        this.getRunnerData(this.$route.params.raceId, 1, true, this.pageIndex)
      } else if (this.currentRaceStatus === 'running' || this.currentRaceStatus === "StartRun") {
        this.getRunnerData(this.$route.params.raceId, 0, false, this.pageIndex)
      }
    },
    async onToggle() {
      if (this.$envdistanceIn === 'Km') {
        this.distanceInKm = false
        Vue.prototype.$envdistanceIn = 'Miles'
        window.localStorage.setItem('distanceIn', 'Miles')
        //this.checkKmMile()
        if (this.notStarted || this.status === "finished") {
          this.getRunnerData(this.$route.params.raceId, 1, false, this.pageIndex)
        }
      } else if (this.$envdistanceIn === 'Miles') {
        this.distanceInKm = true
        Vue.prototype.$envdistanceIn = 'Km'
        window.localStorage.setItem('distanceIn', 'Km')
        //this.checkKmMile()
        if (this.notStarted || this.status === "finished") {
          this.getRunnerData(this.$route.params.raceId, 1, false, this.pageIndex)
        }
      }
    },
    checkKmMile() {
      if (this.$envdistanceIn == 'Miles') {
        this.distanceInKm = false
        this.columns[8].title = 'distance/Miles'
        this.columns[13].title = 'Total mi'
        this.columns[10].title = 'Current Pace(min/mi)'
        this.columns[11].title = 'Total Pace (min/mi)'
      } else {
        this.distanceInKm = true
        this.columns[8].title = 'distance/KM'
        this.columns[13].title = 'Total KM'
        this.columns[10].title = 'Current Pace(min/km)'
        this.columns[11].title = 'Total Pace (min/km)'
      }
    },
    diagnose() {
      this.loading = true
      const AuthStr = 'Bearer '.concat(window.localStorage.getItem('default-auth-token'))
      axios.get(this.expressApi + `diagnose/` + this.$route.params.raceId, {headers: {Authorization: AuthStr}})
        .then(response => {
          this.loading = false
          this.badRunners = response.data
        })

    },
    loaddata() {
      this.getRunnerData(this.$route.params.raceId, 1, false, this.pageIndex)
    },

    removeRunner(id) {
      this.$dialog.confirm("Are you sure you want to Remove Runner?", dialogOptions)
        .then((dialog) => {
          RunnersByRaceService.remove(id, this.$route.params.raceId).then((response) => {
            this.loadingRunners = false
          })
        })
    },
    startBar() {
      this.progressBarInterval = setInterval(() => {
        this.uploadPercentage += 3
        if (this.uploadPercentage > 100) {
          this.stopBar()
        }
      }, 500)
    },
    stopBar() {
      clearInterval(this.progressBarInterval)
    },
    customCompFunc(params) {
      console.log("params---", params)
      if (params.columeName == "luckyLiveRunner") {
        params.race = this.race
        this.detail = params
        this.showModal = true
      } else if (params.columeName == "runnerCalled" || params.columeName == "prePostAnswer") {
        this.tableData[params.index].isRunnerCalled = true
      } else if (params.columeName == "bonusDistance") {
        console.log("bonusDistance>>>>>>>", params)
        params.race = this.race
        this.detail = params
        this.showBonusModal = true
      }

    },
    onClosed() {
      this.showModal = false
      this.showBonusModal = false
    },
    onSaved(data, index) {
      this.tableData[index].isLuckyLiveRunner = true
      this.tableData[index].LuckyLiveRunnerInfo = data
      this.showModal = false
    },
    removeDimDiv() {
      var el = document.getElementById("dim-panel")
      el.classList.remove("dimmer")
    },
    isJson(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    },
    closeSocket() {
      console.log("innnnnnnnnnn")
      SocketService.close()
    },
    handleMessage(msg) {
      //console.log("msg>>>",msg)
      this.loading = false
      if (this.isJson(msg)) {
        let response = JSON.parse(msg)
        console.log('response*********', response)
        if (response.Action == 'RunnerData' && response.data != undefined) {
          this.loading = false
          //console.log("raceData---",response.data)
          if (response.data.hasOwnProperty('raceData')) {
            let tempIsExportAsCsv = false
            if (response.data.hasOwnProperty('filters')) {
              tempIsExportAsCsv = response.data.filters.isExportAsCsv
            }
            if (this.isExportAsCsv && tempIsExportAsCsv) {
              this.downloadCSVFirebase(response.data.raceData.racerInfos)
              this.isExportAsCsv = false
            }
            this.raceData = response.data.raceData.racerInfos

            //sort the data by rank, keeping hyphen ranks at the end
            this.raceData.sort((a, b) => {
              if (a.rank === '-' && b.rank === '-') return 0;
              if (a.rank === '-') return 1;
              if (b.rank === '-') return -1;
              return a.rank - b.rank;
            })

            if (!this.isFreeze) {
              /*Filter the runner who don't have runnerID */
              this.tableData = this.raceData.filter((e) => e.id)

              /*FILTER TOTALPACE BY ABOVE 90 */
              if (this.filterTotalPace) {
                this.tableData = this.tableData.filter(item => {
                  if (item.totalPace.replace(/\D/g, '') > 89) {
                    return item
                  }
                })
              }

              // if(this.totalPaceVal != 'All'){
              // this.tableData = this.tableData.filter(item => {
              //         if( item.totalPace.replace(/\D/g,'')>89){
              //             return item
              //         }
              //     })
              // }
              if (response.data.raceData.pageTotal != undefined) {
                this.totalItems = response.data.raceData.pageTotal
                this.totalJoinedRunner = response.data.raceData.totalJoinedRunner
              }

              // get distance,gap,total distance in mile
              if (!this.distanceInKm) {
                this.tableData.forEach(function (n) {
                  n.totalDistance = n.totalDistanceInMile
                  n.distance = n.distanceInMile
                  //n.gap = n.gapInMile
                  n.pace = n.paceInMile
                })
              }
              this.checkKmMile()
            }
            this.isLoading = false
            this.isDetailApi = response.data.apiBroken
            this.loadingRunners = false
            this.isComplete = true
            if (this.raceCount > 9) {
              this.masterCheck = false
              this.uploadPercentage = 100
            }
          } else {
            this.isComplete = true
          }
          this.isRequestComplete = response.data.isRequestComplete
          this.isComplete = true
          response = null

        } else {
          this.loading = false
          this.loadingRunners = false
          this.isComplete = true
          _LTracker.push('Catching Error from API Server!')
          //console.log("Error from Api -->",e)
        }

      } else {
        console.log("Message>>", msg)
      }

      // always executed
      if (this.tableData.length > 0)
        this.count++

      if (this.count == 1) {
        $('.v-table-views ').css('max-height', '612px')
        $($(".v-table-body")[0]).css('max-height', '550px')
        $($(".v-table-body")[1]).css('max-height', '550px')
        var table = $($(".v-table-body")[1])
        var scrollBar = $("#top-scroll")
        scrollBar.scroll(function () {
          table.scrollLeft(scrollBar.scrollLeft())
        })

        table.scroll(function () {
          scrollBar
            .scrollLeft(table.scrollLeft())
        })
        scrollBar.show()

      }
    },
    handleError(msg) {
      console.log("Soket erorr>>>>", msg)
      this.loading = false
      this.loadingRunners = false
      this.isComplete = true
    },
    handleClose(msg) {
      console.log("Socket close>>>>", msg)
      this.loading = false
      this.loadingRunners = false
      this.isComplete = true
    },
  },
  created() {
    let that = this
    //FILTER BUTTON IN HEADER
    setTimeout(function () {
      //$("div.mytext ul li").first().text("meeeeeeeee")
      $("td.title-cell-class-name-gender ul li:first a").first().text("All")
      // $("td.title-cell-class-name-pace ul li:first a").first().text("All")
      // $( "td.title-cell-name-totalDistance .table-title span" ).after( "<button class='filter-Icon'></button>" )
      // $( "td.title-cell-name-totalRuns .table-title span" ).after( "<button class='filter-Icon'></button>" )
    }, 100)


    SocketService.connect()

    SocketService.$on("message", this.handleMessage)
    SocketService.$on("error", this.handleError)
    SocketService.$on("close", this.handleClose)

    // WebSocketService.wsconnection.onopen = async e => {
    //     console.log("Onopen",e)
    // }

    // //CREATE WEBSOCKET CONNECTION
    // WebSocketService.createConnection()
    // //console.log(">>>>>>",WebSocketService.webconnection)

    // //ON WEBSOCKET CONNECTION OPEN
    // WebSocketService.wsconnection.onopen = async e => {
    //     console.log("Onopen",e)
    // }

    // //ON WEBSOCKET CONNECTION CLOSE
    // WebSocketService.wsconnection.onclose = (e)=> {
    //     console.log("Socket close :",e)
    //     that.loading=false
    //     that.loadingRunners = false
    //     that.isComplete  = true
    //     // //After 5 sec again try to connect to websocket
    //     // setTimeout(function(){
    //     //     WebSocketService.createConnection()
    //     // }, 5000)
    // }

    // //WHEN THERE IS ERROR IN WEBSOCKET CONNECTION
    // WebSocketService.wsconnection.onerror = function(err) {
    //     console.error('Socket encountered error: ', err, 'Closing socket')
    //     that.loading=false
    //     that.loadingRunners = false
    //     that.isComplete  = true
    //     WebSocketService.wsconnection.close()
    // }


    //     this.exampleItems= [...Array(1000).keys()].map(i => ({ id: (i+1), name: 'Item ' + (i+1) }))
    //  this.totalItems=this.exampleItems.length
    //this.exampleItems= []

    if (window.location.protocol === 'https:' && Name === 'st6') {
      this.expressApi = window.location.protocol + '//trainerapi-s1.liverunapp.com:3107/'
    } else if (window.location.protocol === 'http:' && Name === 'st6') {
      this.expressApi = window.location.protocol + '//trainerapi-s1.liverunapp.com:3007/'
    }

    if (window.location.protocol === 'https:' && Name === 'st5') {
      this.expressApi = window.location.protocol + '//trainerapi-s.liverunapp.com:3105/'
    } else if (window.location.protocol === 'http:' && Name === 'st5') {
      this.expressApi = window.location.protocol + '//trainerapi-s.liverunapp.com:3005/'
    }

    if (window.location.protocol === 'https:' && Name === 'st4') {
      this.expressApi = window.location.protocol + '//trainerapi.liverunapp.com:3104/'
    } else if (window.location.protocol === 'http:' && Name === 'st4') {
      this.expressApi = window.location.protocol + '//trainerapi.liverunapp.com:3004/'
    }

    this.expressApi = window.location.protocol + '//localhost:3007/'

    let _this = this

    var interval = setInterval(async function () {
      _this.liveStatus = await db.ref(`/${_this.$fbDbEntry}/${_this.$route.params.raceId}/statusLive`).once('value')
      _this.status = _this.liveStatus.val()
      _this.runStatus = await db.ref(`/${_this.$fbDbEntry}/${_this.$route.params.raceId}/status`).once('value')
      // let raceStatus = runStatus.val()
      // _this.currentRaceStatus = raceStatus
      _this.currentRaceStatus = _this.runStatus.val()

      if (_this.status === "finished") {
        // _this.loading=true
        _this.getRunnerData(_this.$route.params.raceId, 1, true, _this.pageIndex)
        _this.notStarted = false
        clearInterval(interval)
        _this.removeDimDiv()
      } else {
        _this.notStarted = true
        if (_this.$route.params.raceId != undefined && (_this.currentRaceStatus === "running" || _this.currentRaceStatus === "StartRun" || _this.currentRaceStatus === "finished") && _this.status != "finished") {
          if (_this.currentRaceStatus === "finished" && _this.raceCount < 15) {
            _this.raceCount++
            //_this.getRunnerData(_this.$route.params.raceId, 0, true)
            //console.log("pageinnnn--",_this.pageIndex)
            _this.getRunnerData(_this.$route.params.raceId, 0, false, _this.pageIndex)
            _this.masterCheck = true
            _this.startBar()

          } else if (!_this.masterCheck) {
            // console.log("innnnn--",_this.isComplete)
            // if(!_this.isComplete){
            //     _this.completeCount++
            //     console.log("hiiiii",_this.completeCount)
            //     if( _this.completeCount >1){
            //         _this.isComplete = true
            //         _this.completeCount = 0
            //     }
            // }
            _this.getRunnerData(_this.$route.params.raceId, 0, false, _this.pageIndex)
          }
        }
      }


      if (_this.currentRaceStatus === "running" || _this.currentRaceStatus === "StartRun" || _this.currentRaceStatus === "finished") {
        _this.notStarted = false
      } else {
        _this.notStarted = true
      }

    }, 5000)
    this.checkKmMile()
  },
  beforeDestroy() {
    this.removeDimDiv()
  },
  destroyed() {
    console.log("CLOSE WEBSOCKET ON PAGE CHANGE")
    //WebSocketService.wsconnection.close()
    SocketService.close()
  },
  components: {
    Container,
    LuckyLiveRunner,
    RunnerPagination,
    BonusDistanceModal
  }
}
Vue.component('runmetrix-page', {
  template: `<span>
                <router-link :to="{ name: 'runner-data',
                params: {runnerId: rowData.id},
                query: {runmetrix:1 }}"
                             target="_blank">
                    {{ rowData.lastName }}
                </router-link>
            </span>`,
  data: () => ({
    //   id:null
  }),
  props: {
    rowData: {
      type: Object
    },
    field: {
      type: String
    },
    index: {
      type: Number
    }
  },
  methods: {},
  created() {
  }
})

Vue.component('runner-id', {
  template: `<span>
        <a href="" @click.stop.prevent="runnerData()">{{ rowData.id }}</a>&nbsp
        </span>`,
  data: () => ({
    //   id:null
  }),
  props: {
    rowData: {
      type: Object
    },
    field: {
      type: String
    },
    index: {
      type: Number
    }
  },
  methods: {
    runnerData() {

      let route = this.$router.resolve({
        name: 'runner-data',
        params: {
          runnerId: this.rowData.id
        }
      })
      window.open(route.href, '_blank')
    }
  },
  created() {
  }
})
Vue.component('runner-medal', {
  template: `
    <img :src="rowData.medal?rowData.medal.imageBadgeUrl:null" :title="rowData.medal?rowData.medal.badge:null"
         style="height:30px; padding-top: 5px;">
  `,
  data: () => ({
    //   id:null
  }),
  props: {
    rowData: {
      type: Object
    },
    field: {
      type: String
    },
    index: {
      type: Number
    }
  },
  methods: {},
  created() {

  }
})
Vue.component('pre-post-answers', {
  template: `
    <div style="width:890px">
      <a href="javascript:void(0)" @click=isPreRead()
         v-bind:style="{ color: preactiveColor }">{{ rowData.questionAnswer }}</a>
      <br/>
      <hr style="margin-bottom: 4px;margin-top: 4px;">
      <span>
                        <a href="javascript:void(0)" @click=isPostRead()
                           v-bind:style="{ color: postactiveColor }"> {{ rowData.postQuestionAnswer }}</a>
                    </span>
    </div>`,
  data: () => ({
    preactiveColor: 'black',
    postactiveColor: 'red'
  }),
  props: {
    rowData: {
      type: Object
    },
    field: {
      type: String
    },
    index: {
      type: Number
    }
  },
  methods: {
    isPreRead() {
      this.preactiveColor = '#a33ef1'
      db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/runners/${this.rowData.id}`).update({
        'preAnswerRead': true,
        'isRunnerCalled': true,
      })
      let params = {columeName: "prePostAnswer", runner: this.rowData, index: this.index}
      this.$emit('on-custom-comp', params)
    },
    isPostRead() {
      this.postactiveColor = '#a33ef1'
      db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/runners/${this.rowData.id}`).update({
        'postAnswerRead': true,
        'isRunnerCalled': true,
      })
      let params = {columeName: "prePostAnswer", runner: this.rowData, index: this.index}
      this.$emit('on-custom-comp', params)
    }
  },
  created() {
    let that = this
    let AnswersInterval = setInterval(async function () {
      let liveStatus = await db.ref(`/${that.$fbDbEntry}/${that.$route.params.raceId}/statusLive`).once('value')
      if (liveStatus.val() === 'finished') {
        clearInterval(AnswersInterval)
      }
      let preAnswerRead = await db.ref(`/${that.$fbDbEntry}/${that.$route.params.raceId}/runners/${that.rowData.id}/preAnswerRead`).once('value')
      let postAnswerRead = await db.ref(`/${that.$fbDbEntry}/${that.$route.params.raceId}/runners/${that.rowData.id}/postAnswerRead`).once('value')
      if (preAnswerRead.val()) {
        that.preactiveColor = '#a33ef1'
      } else {
        that.preactiveColor = 'black'
      }
      if (postAnswerRead.val()) {
        that.postactiveColor = '#a33ef1'
      } else {
        that.postactiveColor = 'red'
      }
    }, 1000)
  }
})
// <span @click  = isRunnerCalled() v-bind:style="{ color: runnerColor ,cursor:'pointer'}">{{rowData.firstName}}</span>
Vue.component('runner-name', {
  template: `
    <div>
      <span
        v-if="rowData.isNotSubscribed || !rowData.isJoined ">{{ rowData.firstName }}</span>
      <span v-else-if="rowData.isNew"
            v-bind:style="[rowData.isRunnerCalled ? {'color':'purple','cursor':'pointer','font-weight': 'bold'} : {'color':'red','cursor':'pointer'}]">{{ rowData.firstName }}</span>
      <span v-else @click.stop.prevent="runnerCalled()"
            v-bind:style="[rowData.isRunnerCalled ? {'color':'purple','cursor':'pointer'} : {'color':'black','cursor':'pointer'}]">{{ rowData.firstName }}</span>
    </div>`,
  data: () => ({
    //runnerColor:'',
    //runnerCalledFB:'',
    //runnerCalled:false
  }),
  props: {
    rowData: {
      type: Object
    },
    field: {
      type: String
    },
    index: {
      type: Number
    }
  },
  methods: {
    runnerCalled() {
      // this.runnerColor = 'red'
      db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/runners/${this.rowData.id}`).update({
        'isRunnerCalled': true
      })
      let params = {columeName: "runnerCalled", runner: this.rowData, index: this.index}
      this.$emit('on-custom-comp', params)
    },
  },
  created() {
  },
})


Vue.component('luckylive-runner-modal', {
  template: `
    <div>
      <button id="tickBtn" v-if="rowData.isLuckyLiveRunner"></button>
      <div v-if="rowData.filterEkiden">
        <span v-if="rowData.id =='-'|| !rowData.isRunning || rowData.isNotSubscribed">{{ rowData.bonusRank }}</span>
        <span v-else @click.stop.prevent="openEditModal()" style="cursor:pointer">{{ rowData.bonusRank }}</span>
      </div>
      <div v-else>
        <span v-if="rowData.id =='-'|| !rowData.isRunning || rowData.isNotSubscribed">{{ rowData.rank }}</span>
        <span v-else @click.stop.prevent="openEditModal()" style="cursor:pointer">{{ rowData.rank }}</span>
      </div>
    </div>
  `,
  props: {
    rowData: {
      type: Object
    },
    field: {
      type: String
    },
    index: {
      type: Number
    },
  },
  methods: {
    openEditModal() {
      let params = {columeName: "luckyLiveRunner", runner: this.rowData, index: this.index}
      this.$emit('on-custom-comp', params)
    }
  },
  created() {
  }
})

Vue.component('bonus-distance-modal', {
  template: `
    <div>
      <span v-if="rowData.filterEkiden" @click.stop.prevent="openAddBonusModel()"
            style="cursor:pointer">{{ rowData.TotalBoostDistance }}</span>
      <span v-else @click.stop.prevent="openAddBonusModel()" style="cursor:pointer">{{ rowData.distance }}</span>
    </div>
  `,
  props: {
    rowData: {
      type: Object
    },
    field: {
      type: String
    },
    index: {
      type: Number
    },
    filterEkiden: {
      type: Boolean
    }

  },
  methods: {
    openAddBonusModel() {
      console.log("this.filterEkiden>>>>>>>>", this.$parent)
      let params = {columeName: "bonusDistance", runner: this.rowData, index: this.index}
      this.$emit('on-custom-comp', params)
    }
  },
  created() {
  }
})


</script>


<style>
#tickBtn {
  width: 20px;
  height: 13px;
  /* margin-top: 10px; */
  /* float: left; */
  margin-right: 2px;
  background-image: url(../../../assets/tick.png);
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
}

/* .isLuckyRunner{
    display: none
} */
.column-cell-class-name-test {
  background-color: rgb(224, 4, 4);
}

.column-cell-class-name-red-text {
  color: rgb(224, 4, 4);
}

.column-cell-class-name-pink {
  background-color: #FFB6C1;
}

.column-cell-class-name-test-memo .v-table-body-cell {
  white-space: initial !important;
  line-height: 15px !important;
  font-size: 10px;
  /* height: 50px !important; */
}

.column-cell-class-name-test .v-table-body-cell {
  border-color: rgb(224, 4, 4);
}

.column-cell-class-name-test1 .v-table-body-cell {
  line-height: 10px !important;
  white-space: nowrap !important;
  word-wrap: normal !important;
  vertical-align: middle;
  display: table-cell;

}

#apierror .live-run ul li {
  float: left;
  margin: 20px 0 20px 35px;
  font-size: 11px !important;
}

#apierror .chip {
  display: inline-block;
  padding: 7px 32px;

  font-size: 14px;

  border-radius: 10px;
  background-color: #f1f1f1;
}

#apierror button#Diagnose {
  margin-bottom: 15px;
  margin-top: 15px;
  float: right;
}

#apierror .live-run ul {
  width: 72%;
  display: inline-block;
  float: right;
  text-align: right;
}

#apierror .chip button {
  background: none;
  border: none;
  position: relative;
  left: 10px;
}

.loader {
  border: 6px solid #f3f3f3;
  border-radius: 50%;
  border-top: 6px solid #3498db;
  width: 40px;
  height: 40px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

.leftbtn {
  float: right;
}

/* .loadRunnersBtn{
    font-weight: 700;
    color: #fff;
    background-color: #423799;
    padding: 0px 10px;
    border-radius: 20px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
} */


.roundBtn {
  font-weight: 700;
  color: #fff;
  padding: 0px 10px;
  border-radius: 20px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  border: transparent;
  position: sticky;
}

.loadRunnersBtn {
  background-color: #423799 !important;
}

.freezeBtn {
  background-color: red !important;
}

.unfreezeBtn {
  background-color: #52AD69 !important;
}

.btnContainer {
  border-bottom: 1px solid #e8e8e8;
  padding: 10px 0;
  margin-top: -55px;
}

.loadRunners {
  font-weight: 700;
  color: #fff;
  background-color: #423799;
  padding: 0px 10px;
  /* text-transform: uppercase; */
  position: sticky;
  left: 90%;
  transform: translateX(-50%);
  border-radius: 20px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.freezeData {
  width: 95px;
  margin-right: 15px;
  font-weight: 700;
  color: #fff;
  background-color: red;
  border: transparent;
  padding: 0px 15px;
  position: sticky;
  left: 90%;
  /* transform: translateX(-50%); */
  border-radius: 20px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.unfreezeData {
  width: 95px;
  margin-right: 15px;
  font-weight: 700;
  color: #fff;
  background-color: #52AD69;
  border: transparent;
  padding: 0px 15px;
  position: sticky;
  left: 90%;
  /* transform: translateX(-50%); */
  border-radius: 20px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.dimmer {
  /* background: #0000001f; */
  /* background: #807f7f47; */
  /* background: #e5e5e573;
  filter: brightness(90%); */
  background: #bfbfbf91;
  filter: brightness(75%);
}

.title-cell-name-totalDistance {
  cursor: pointer;
}

.purple-bg {
  background: #454598 !important;
  color: white;
}

.filter-Icon {
  background-image: url(../../../assets/filter-icon.png);
  height: 20px;
  width: 20px;
  border: none;
  background-repeat: no-repeat;
  background-color: transparent;
  cursor: pointer;
  outline: transparent;
}

.runner-table .column-cell-class-name-firstname .v-table-body-cell.vertical-border.horizontal-border {
  line-height: initial !important;
  text-align: left !important;
  white-space: initial !important
}

.filter-btn {
  padding: 20px 20px 2px 20px;
  background: #f9f9f9;
}

.filter-btn button {
  cursor: pointer;
  /* background: #454597;
  color: white; */
  background: white;
  margin-right: 15px;
  height: 35px;
  width: 100px;
  border: none;
  outline-color: transparent;
  border-radius: 4px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.pager_btns {
  display: flex;
  background: #f9f9f9;
}


/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}


::-webkit-scrollbar {
  width: 10px;
  height: 12px;
}


::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}


::-webkit-scrollbar-thumb {
  background: #555;
  border-radius: 5px;
}

/* progress::-webkit-progress-value {
    background-color: #eee;
    border-radius: 5px;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25) inset;
    position: relative;
} */
/*
 * Gradient Shadow
 */

/* All HTML5 progress enabled browsers */
progress {

  /* Turns off styling - not usually needed, but good to know. */
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  /* gets rid of default border in Firefox and Opera. */
  border: solid #cccccc6e 3px;
  border-radius: 5px;
  height: 20px;
  background: #cccccc !important; /* !important only needed in polyfill */
}

/* Polyfill */
progress[role]:after {
  background-image: none; /* removes default background from polyfill */
}

/*
 * Background of the progress bar background
 */


/* Chrome */
progress::-webkit-progress-bar {
  background: #cccccc;
}

/*
 * Background of the progress bar value
 */

/* Firefox */
progress::-moz-progress-bar {
  border-radius: 5px;
  background-image: -moz-linear-gradient(
    center bottom,
    rgb(59, 53, 134) 37%,
    rgb(71, 61, 211) 69%
  );
}

/* Chrome */
progress::-webkit-progress-value {
  border-radius: 5px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0, rgb(59, 53, 134)),
    color-stop(1, rgb(71, 61, 211))
  );
  background-image: -webkit-linear-gradient(
    center bottom,
    rgb(59, 53, 134) 37%,
    rgb(71, 61, 211) 69%
  );
}

/* Polyfill */
progress[aria-valuenow]:before {
  border-radius: 5px;
  background-image: -moz-linear-gradient(
    center bottom,
    rgb(59, 53, 134) 37%,
    rgb(71, 61, 211) 69%
  );
  background-image: -ms-linear-gradient(
    center bottom,
    rgb(59, 53, 134) 37%,
    rgb(71, 61, 211) 69%
  );
  background-image: -o-linear-gradient(
    center bottom,
    rgb(59, 53, 134) 37%,
    rgb(71, 61, 211) 69%
  );

}
</style>



// WEBPACK FOOTER //
// RunnersTable.vue?549d9165